export default "__VITE_ASSET___l29SKh$__"